import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { RootState } from "../../store";
import config from "../../config";

export const baseQuery = (prefix: string) =>
  fetchBaseQuery({
    baseUrl: config.apiUrl + prefix,
  });

export const baseAuthQuery = (prefix: string) =>
  fetchBaseQuery({
    baseUrl: config.apiUrl + prefix,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.accessToken;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      const xAuth = (getState() as RootState).auth.xAuth;
      if (xAuth) {
        headers.set("X-Auth", xAuth);
      }
      return headers;
    },
    responseHandler: async (response) => {
      if (response.status === 401) {
        localStorage.removeItem("accessToken");
        window.location.href = "/login";
        return null;
      }
      return response.json();
    },
  });
